import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface BannerConfig {
  message: string;
  tone?: 'success' | 'danger' | 'warning' | 'info' | 'primary-brand';
  variant?: 'toast' | 'system';
  duration?: number;
  dismissible?: boolean;
  customColor?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BannerService {
  private bannerSubject = new Subject<BannerConfig>();
  public banner$ = this.bannerSubject.asObservable();

  showSuccess(message: string, duration: number = 5000): void {
    this.bannerSubject.next({
      message,
      tone: 'success',
      variant: 'toast',
      duration,
      dismissible: true
    });
  }

  showError(message: string, duration: number = 5000): void {
    this.bannerSubject.next({
      message,
      tone: 'danger',
      variant: 'toast',
      duration,
      dismissible: true
    });
  }

  showWarning(message: string, duration: number = 5000): void {
    this.bannerSubject.next({
      message,
      tone: 'warning',
      variant: 'toast',
      duration,
      dismissible: true
    });
  }

  showInfo(message: string, duration: number = 5000): void {
    this.bannerSubject.next({
      message,
      tone: 'info',
      variant: 'toast',
      duration,
      dismissible: true
    });
  }

  showWithColor(message: string, color: string, duration: number = 5000): void {
    this.bannerSubject.next({
      message,
      customColor: color,
      variant: 'toast',
      duration,
      dismissible: true
    });
  }
}
